import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  columns,
  filters,
  searchBy,
} from "../../../service/AUSubcategoryService";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import { SubCategoryApi } from "../../../App/api/menu.apis";
import { ApproveUnapproveApi } from "../../../App/api/a&uApi";
import { toast } from "react-toastify";
import CustomModal from "../../../custom/modal/customModal";
import CommonRejectTemplate from "../../../Components/CommonRejectTemplate";
import { SubCategoryForm } from "./SubCategoryModal";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";
import { useSelector } from "react-redux";

const AUSubcategoryComponent = ({ pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const currentUser = useSelector((state) => state.store.currentUser);
  const user = currentUser?.data?.user;
  const [selectedOrder, setSelectedSubcategory] = useState(null);
  const [subcategoryData, setPromocodeData] = useState(null);
  const [isRejectSubcategoryModalOpen, setIsRejectSubcategoryModalOpen] =
    useState(false);
  const [actionData, setActionData] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);

  const getAllSubcategory = async () => {
    try {
      const res = await SubCategoryApi.getSubCategory(pagination, search);

      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }

    try {
      const approvalStatus = await approvalStatusApi.getAllApprovalStatuses({
        filter: { component: "SubCategory", },
      });
      setApprovalStatus(approvalStatus?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };



  const handleCellClick = async (row, action) => {
    if (action === "Rejected") {
      setIsRejectSubcategoryModalOpen(true);
      setSelectedSubcategory(row);
      setActionData(action);
    } else if (action === "Approved") {
      setActionData(action);
      setSelectedSubcategory(row);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllSubcategory();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={subcategoryData?.subcategories}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: subcategoryData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: subcategoryData?.totalPages || 1,
          totalCount: subcategoryData?.totalCount || 1,
        }}
        onCellClick={(e) => {
          // console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />

      {actionData === "Approved" && (
        <SubCategoryForm
          handleClose={() => setActionData(null)}
          selectedOrder={selectedOrder}
          getAllSubcategory={getAllSubcategory}
          user={user}
          actionData={actionData}
          setActionData={setActionData}
          approvalStatus={approvalStatus}
          initialValues={{
            name: selectedOrder?.name || "",
            sequence: selectedOrder?.sequence || "",
            category: selectedOrder?.category || "",
            is_visible: selectedOrder?.is_visible || false,
            categoryType: "Ecommerce",
          }}
        />
      )}
      <CustomModal
        isOpen={isRejectSubcategoryModalOpen}
        onClose={() => setIsRejectSubcategoryModalOpen(false)}
        title="Reject Subcategory"
      >
        <CommonRejectTemplate
          data={selectedOrder}
          actionData={actionData}
          name={selectedOrder?.name}
          getAllData={getAllSubcategory}
          endpoint={ApproveUnapproveApi.updateSubCategoryApprovalStatus}
          closeModal={setIsRejectSubcategoryModalOpen}
          component="SubCategory"
          approvalStatus={approvalStatus}
        />
      </CustomModal>
    </div>
  );
};

export default AUSubcategoryComponent;
